import Dropzone, { Accept } from "react-dropzone";
import Upload from "./icons/upload";

type FileUploadProps = {
  filesAdded: (files: File[]) => void;
  accept: string;
  fileDisplay: string;
  multiple?: boolean;
};

const FileUpload = (props: FileUploadProps) => {
  const filesAdded = props.filesAdded;
  const accept = props.accept;
  const multiple = props.multiple;
  const fileDisplay = props.fileDisplay;
  const filesDropped = (files: File[]) => {
    filesAdded(files);
  };

  const acceptOption: Accept = {};
  acceptOption[accept] = [accept];

  return (
    <div className="text-center mt-4 bg-blue-100 border border-dashed border-primary-blue rounded-md w-full p-12">
      <Dropzone onDrop={filesDropped} accept={acceptOption} multiple={multiple}>
        {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
          <div
            {...getRootProps()}
            className="w-full h-full flex items-center justify-center"
          >
            <input {...getInputProps()} />
            <div className="flex flex-col items-center justify-center gap-2">
              <Upload className="h-12 w-12" />
              {!isDragActive && (
                <div>
                  Drag and drop or
                  <div>
                    <span className="cursor-pointer text-primary-blue font-semibold">
                      Browse
                    </span>{" "}
                    your computer
                  </div>
                </div>
              )}
              {isDragActive && !isDragReject && `Drop ${fileDisplay} to Add`}
              {isDragActive && isDragReject && "Invalid file type"}
            </div>
          </div>
        )}
      </Dropzone>
    </div>
  );
};

export default FileUpload;
